<template>
	<nav class="pagination" role="navigation" aria-label="pagination">
		<ul class="pagination-list">
			<li class="pagination-prev" tabindex="0">
				<span class="pagination-previous sr-only">Previous page</span>
				<span class="icon icon-angle-double-left" 
					  v-on:click.prevent="changePage(pagination.current_page - 1)"
					  v-on:keyup.enter="changePage(pagination.current_page - 1)"
					  :disabled="pagination.current_page <= 1"></span>
			</li>

			<li v-for="page in pages" class="pagination-page" tabindex="0" :aria-label="'Page ' + page">
				<span class="pagination-link" 
					  :class="isCurrentPage(page) ? 'active' : ''" 
					  v-on:click.prevent="changePage(page)"
					  v-on:keyup.enter="changePage(page)">{{ page }}</span>
			</li>

			<li class="pagination-next" tabindex="0">
				<span class="pagination-next sr-only">Next page</span>
				<span class="icon icon-angle-double-right" 
					  v-on:click.prevent="changePage(pagination.current_page + 1)" 
					  v-on:keyup.enter="changePage(pagination.current_page + 1)"
					  :disabled="pagination.current_page >= pagination.end_page"></span>
			</li>
		</ul>
	</nav>
</template>

<script>
    export default {
		props: ['pagination'],

		methods: {
            isCurrentPage(page) {
                return this.pagination.current_page === page;
            },
            changePage(page) {
				if (page > this.pagination.end_page) {
					page = this.pagination.end_page;
					return
				}
				else if (page < 1) {
					page = 1;
					return
				}

				this.pagination.current_page = page;
                this.$emit('paginate');
            }
        },
        computed: {
            pages() {
                let pages = [];

                let from = this.pagination.start_page;
                let to = this.pagination.end_page;

                while (from <= to) {
                    pages.push(from);
                    from++;
                }

                return pages;
            }
        }
    }
</script>